import { getApiKey } from "../../utils/apiKey";
import React, { Component } from "react";
import Header from "../header";
import { apiCall_domain } from "../api";
import axios from "axios";
import Spinner from "../Spinner/Spinner";
import { createGlobalStyle } from "styled-components";
import { Link } from "react-router-dom";
import PulseLoader from "react-spinners/PulseLoader";

class MyFavorite extends Component {
  state = {
    Favorites: [],
    loading: false,
    error: null,
    btnLoading: false,
    id: "",
  };

  componentDidMount() {
    this.getData();
  }
  getData = () => {
    this.setState({ loading: true }, () => {
      const headers = {
        Authorization: getApiKey(),
        "content-type": "application/json",
      };
      axios
        .get(`${apiCall_domain}/customer/user/get_favorite_items`, {
          headers: headers,
        })
        .then((res) => {
          this.setState({ loading: false, Favorites: res.data.data });
        });
    });
  };
  render() {
    const GlobalStyles = createGlobalStyle`body{
      background: #FAFAFA !important;
    }`;
    const removeFavourite = (id) => {
      const Headers = {
        Authorization: getApiKey(),
        "content-type": "application/json",
      };
      axios
        .post(
          `${apiCall_domain}/customer/user/delete/favorite_item`,
          { item_id: id },
          { headers: Headers },
        )
        .then((res) => {
          this.getData();
        });
    };
    return (
      <>
        {this.state.loading ? (
          <Spinner />
        ) : (
          <>
            <GlobalStyles />
            <Header
              showSearchBar={true}
              title={"علاقمندی ها"}
              backUrl={"/profile"}
            />
            {this.state?.Favorites.length ? (
              <div className="myFavoriteContainer">
                {this.state.Favorites.map((favorite, index) => (
                  <main className="MyFavorite">
                    <div className="Favorite" key={index}>
                      <img
                        src="/public/assets/icons/profile/filledheart.svg"
                        alt="heart"
                        className="heartIcon"
                        onClick={() => {
                          removeFavourite(favorite.id);
                        }}
                      />
                      <Link to={`/Product/${favorite.id}`}>
                        <div className="FavoriteImage">
                          <img src={favorite.pic} alt="عکس محصول" />
                        </div>
                        <div className="FavoriteGoldeston">
                          <span className="title">{favorite.name}</span>
                        </div>
                        {favorite.price != 0 ? (
                          favorite.percent_price ? (
                            <>
                              <div className="FavoriteCost">
                                <span className="FavoritePrice">
                                  {favorite.old_price.toLocaleString()}
                                </span>
                                <span className="FavDiscount">
                                  {favorite.percent_price} %
                                </span>
                              </div>
                              <div className="sectionPrice">
                                <span className="FavoritePrice">
                                  تومان {(+favorite.price).toLocaleString()}
                                </span>
                              </div>
                            </>
                          ) : (
                            <div className="sectionPrice">
                              <span className="FavoritePrice">
                                تومان {(+favorite.price).toLocaleString()}
                              </span>
                            </div>
                          )
                        ) : (
                          <div className="noStock">
                            <span className="noStock danger">ناموجود</span>
                          </div>
                        )}
                      </Link>
                    </div>
                  </main>
                ))}
              </div>
            ) : (
              <div className="danger emptyText">
                <span>هیچ محصولی در علاقمندی شما وجود ندارد</span>
              </div>
            )}
            <div className="pag pag--primary">
              {/* //TODO : compelete when we have api */}
              {/* <Stack spacing={2}>
                <Pagination count={7} />
              </Stack> */}
            </div>
          </>
        )}
      </>
    );
  }
}
export default MyFavorite;
